import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { history } from "../../../routers/AppRouter";
import moment from 'moment';
import styled from 'styled-components'
import { useTable, useRowSelect } from 'react-table';
import { connect } from "react-redux";

import { getUsers, removeUsers } from '../../../actions/users';
import MainButton from '../../../components/MainButton';
import { toast, ToastContainer } from 'react-toastify';

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`;

const HeadingContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledHeading = styled.div`
  padding: 10px 10px 10px 0;
  font-size: 40px;
`;

const ButtonPadding = styled.div`
  padding: 0 5px;
`;

const Title = styled.div`
  cursor: pointer;
`;

const ButtonStyle = styled.button`
  cursor: pointer;
`;

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input type="checkbox" ref={resolvedRef} {...rest} />
      </>
    )
  }
);

const handleEditRow = (id) => {
  history.push(`edit-user/${id}`);
};

const createPost = () => {
  history.push('/user')
};

function Table({ columns, data, deleteSelectedUsers, onBulkChange, bulkUpdate }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
    },
    useRowSelect,
    hooks => {
      hooks.allColumns.push(columns => [
        // Let's make a column for selection
        {
          id: 'selection',
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (
            <div>
              <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ])
    }
  );

  // Render the UI for your table
  return (
    <>
      <HeadingContainer>
        <StyledHeading>Users</StyledHeading>
        <MainButton title="Create A User" onClick={() => createPost()} />
        <ButtonPadding><MainButton title="Delete Users" onClick={() => deleteSelectedUsers(selectedFlatRows)} /></ButtonPadding>
      </HeadingContainer>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.slice(0, 3500).map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      <p>Selected Rows: {Object.keys(selectedRowIds).length}</p>
      <pre>
        <code>
          {JSON.stringify(
            {
              selectedRowIds: selectedRowIds,
              'selectedFlatRows[].original': selectedFlatRows.map(
                d => d.original
              ),
            },
            null,
            2
          )}
        </code>
      </pre>
      <ToastContainer />
    </>
  )
}

function UserList(props) {

  const [bulkValue, setBulkValue] = useState('');

  // had to be in here to get be able to fire props dispatch
  const deleteSelectedUsers = (selectedRows) => {
    let userIdsToDelete = [];
    selectedRows.map((item) => {
      userIdsToDelete.push(parseInt(item.original.id, 10)); // original is the actual object info
    });
    props.removeUsers(userIdsToDelete);
  };

  useEffect(() => {
    props.getUsers();
  }, []);

  useEffect(() => {
    if (props.removeSuccess) {
      toast.success('Users Removed Successfully');
    }

  }, [props.removeSuccess]);

  useEffect(() => {
    if (props.removeError) {
      toast.error('Error Removing Users');
    }

  }, [props.removeError]);

  const onBulkChange = (e) => {
    const bulkValue = e.target.value;
    console.log(bulkValue);
    setBulkValue(bulkValue);
  };

  // update selected all selected rows in database with table name, field to update and what new value
  // fieldName is the actual fieldName in the databae row
  const bulkUpdate = (selectedRows, fieldName) => {
    // console.log('bulkValue: ', bulkValue);
    let selectedPostIds = [];
    selectedRows.map((item) => {
      selectedPostIds.push(parseInt(item.original.id, 10)); // original is the actual object info
    });
    selectedPostIds.map((itemId) => {
      console.log(itemId);
    })

    let bulkDetails = {
      postIds: {
        selectedPostIds: [selectedPostIds]
      },
      newValue: bulkValue,
      tableName: 'jobs',
      fieldName: fieldName,
    };

    props.bulkUpdate(bulkDetails);
  }

  const columns = React.useMemo(
    () => [
      {
        Header: 'User Info',
        columns: [
          {
            Header: 'ID',
            accessor: data => {
              return <Title onClick={() => handleEditRow(data.id)}>{data.id}</Title>;
            },
          },
          {
            Header: 'Email',
            accessor: data => {
              return <Title onClick={() => handleEditRow(data.id)}>{data.email}</Title>;
            },
          },
          {
            Header: 'Assigned to Client ID',
            accessor: data => {
              return <Title onClick={() => handleEditRow(data.id)}>{data.clientId}</Title>;
            },
          },
          {
            Header: 'Qualified Lead',
            accessor: data => {
              return (
                <Title onClick={() => handleEditRow(data.id)}>
                  {data.profile?.qualifiedLead ? 'True' : 'False'}
                </Title>
              );
            },
          },
          {
            Header: 'Role',
            accessor: data => {
              return <Title onClick={() => handleEditRow(data.id)}>{data.role}</Title>;
            },
          },
          {
            Header: 'Created At',
            accessor: d => {
              return moment(d.createdAt).format('MMM. Do, YYYY');
            }
          },
          {
            Header: 'Edit',
            accessor: data => {
              return <ButtonStyle onClick={() => handleEditRow(data.id)}>Edit</ButtonStyle>;
            },
          },
        ],
      },
    ],
    []
  );

  return (
    <Styles>
      <Table
        columns={columns}
        data={props.users}
        deleteSelectedUsers={deleteSelectedUsers}
        onBulkChange={onBulkChange}
        bulkUpdate={bulkUpdate}
      />
    </Styles>
  )
}

const mapStateToProps = (state) => {
  return {
    users: state.users.data,
    removeError: state.users.removeError,
    removeSuccess: state.users.removeSuccess
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUsers: () => dispatch(getUsers()),
  removeUsers: (idsToDelete) => dispatch(removeUsers(idsToDelete)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserList);
